import React, { FunctionComponent, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Box,
    Button,
    FormControl,
    Stack,
    Typography
} from "@mui/material";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { mdiFile } from "@mdi/js"
import { Icon } from "@mdi/react";
import { IProps } from "./IProps";

const FilePreview: FunctionComponent<{ matrix: string[][] }> = ({ matrix }): JSX.Element => {
    return (
        <Stack mt={4}>
            {matrix.length > 0 && (
                <table style={{ width: "100%", border: "#1BA0E9 solid" }}>
                    <thead>
                        <tr>
                            {matrix[0].map((cell) => (
                                <th style={{ border: "inherit", backgroundColor: "#1BA0E9", color: "white", padding: 4 }}>{cell}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {matrix.slice(1, 11).map((row) => (
                            <tr>
                                {row.map((cell) => (
                                    <td style={{ textAlign: "center" }}>
                                        <Typography sx={{ fontWeight: 400, fontSize: 14 }} >
                                            {cell}
                                        </Typography>
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </Stack>
    )
}

export const FormFileDialog: FunctionComponent<IProps> = (props) => {
    const [showPreview, setShowPreview] = useState<boolean>(true);

    return (
        <Dialog
            fullWidth
            maxWidth="xs"
            open={props.isOpen}
        >
            <DialogTitle sx={{ color: "#1BA0E9", fontWeight: 600, fontSize: 22, letterSpacing: 0.5 }}>Upload a file</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Select a .csv from your machine. The required format is zip, dealer id and one custom column.
                    Any other columns or tabs will be ignored.
                </DialogContentText>
                <Box
                    noValidate
                    component="form"
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        m: 'auto',
                        width: 'fit-content',
                    }}
                >
                    <FormControl sx={{ mt: 2, minWidth: 120 }}>
                        <Button
                            startIcon={props.file === null ? <FileUploadIcon /> : <Icon path={mdiFile} size={0.9} color="#1BA0E9" />}
                            variant="outlined"
                            onClick={props.onOpenSelectionFile}
                            color={props.isError ? "error" : "primary"}
                        >
                            {props.file === null ? "Upload a file" : props.file?.name}
                        </Button>
                    </FormControl>
                    {(props.file && !props.isError) && (
                        <Stack direction="column">
                            <Box display="flex" alignItems="center" justifyContent="center" mt={2} >
                                <Typography fontSize={12} sx={{ color: "#1BA0E9", cursor: "pointer", userSelect: "none" }} onClick={() => setShowPreview(!showPreview)}>
                                    {showPreview ? "Close Preview" : "See Preview"}
                                </Typography>
                            </Box>
                            { showPreview && <FilePreview matrix={props.textMatrix} /> }
                        </Stack>
                    )}
                    {(props.fileMessage && props.isError) && (
                        <Stack direction="row" mt={2} spacing={0.5} >
                            <Typography
                                sx={{ fontSize: 12, color: "red" }}
                            >
                                {props.fileMessage}
                            </Typography>
                        </Stack>
                    )}
                    <input accept=".csv" id="btn-file-upload" type="file" style={{ display: "none" }} onChange={props.onHandleSelectionFile} />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" disabled={props.file === null} onClick={props.onSave}>Save</Button>
                <Button onClick={props.onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    )
}